export const demoContractMotifs = [
  "EXEMPLE : Renfort temporaire de préparation des commandes",
  "EXEMPLE : Remplacement d’un salarié absent",
];
export const demoContractQualification = {
  IdQualification: "TEST-PREPARATEUR",
  TxtQualification: "Préparateur de commandes",
  Niveau: "1",
  CoeffHeures: 1.85,
  TauxPaye: 13.5,
  PCS: "Exemple",
};
export function mouradContractExample() {
  return {
    motif: demoContractMotifs[0],
    justificatif: "Exemple fictif : préparation d’une campagne de commandes.",
    startDate: new Date(2026, 9, 19),
    endDate: new Date(2026, 9, 23),
    startHour: new Date(2026, 9, 19, 8),
    endHour: new Date(2026, 9, 19, 16),
    clientQualification: { ...demoContractQualification },
    address: "12 rue de l’Entrepôt (adresse fictive)",
    postCode: "93200",
    town: "Saint-Denis",
    EstChezClient: "O",
    EstBTP: "N",
    task: "Réception des colis, préparation des commandes, contrôle et emballage.",
    consigne:
      "1 : Port des EPI obligatoire. Le respect des règles de sécurité et d'hygiène est obligatoire.",
    Reference1: "TEST-MOURAD-2026",
    Reference2: "DEMONSTRATION",
    Horaires: "Pause de 12 h à 13 h (exemple)",
    PeriodeNonTrav: "Samedi et dimanche",
    NbJourEssai: "2",
    PenibiliteNC: "O",
  };
}
